var pendingExportJobsChecked = false;

export default class RtbLogsService {

  /** @ngInject **/
  constructor(
    $http,
    assetService,
    ngAuthSettings,
    utils,
    cacheService
  ) {
    this.$http = $http;
    this.assetService = assetService;
    this.ngAuthSettings = ngAuthSettings;
    this.utils = utils;
    this.cacheService = cacheService;
    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
  }

  async exportRtbLogs(accountId, settings, exportName, dontStoreInCache) {
    if (this.utils.isStaging()) {
      return new Promise(function (resolve) {
        var jobId = 'EJ' + Date.now();

        if (!dontStoreInCache) {
          _addJobIdToCache(accountId, {
            jobId: jobId,
            exportName: exportName,
            newCallLogs: true
          });
        }

        resolve({
          data: {
            id: jobId
          }
        });
      });
    }

    pendingExportJobsChecked = true;
    const url = this.#serviceBaseUrl(accountId) + '/export/csv';
    const result = await this.$http.post(url, settings);
    const jobId = result.data.id;
    if (!dontStoreInCache) {
      _addJobIdToCache(accountId, {
        jobId: jobId,
        exportName: exportName,
        newCallLogs: true
      });
    }
    return result;
  }

  async getExportStatus(accountId, jobId) {
    if (this.utils.isStaging()) {
      return new Promise(function (resolve) {
        resolve({status:'Pending'});
      });
    }
    const url = this.#serviceBaseUrl(accountId) + '/export/' + jobId;
    const result = await this.$http.get(url);

    return result.data;
  }

  async getRtbLog(accountId, bidId) {
    const url = this.#serviceBaseUrl(accountId) + '/bid/' + bidId;
    const result = await this.$http.get(url);

    return result.data;
  }

  _addJobIdToCache(accountId, job) {
    var jobs = this.cacheService.get(_getPendingJobsCacheKey(accountId));
    if (!jobs) {
      jobs = {};
    }

    jobs[job.jobId] = job;
    this.cacheService.set(_getPendingJobsCacheKey(accountId), jobs, {
      persistence: true
    });
  }

  _getPendingJobsCacheKey(accountId) {
    return 'pendingExportJobs-' + accountId;
  }
  
  #serviceBaseUrl(accountId) {
    return this.serviceBaseUri + accountId + '/rtb';
  }
}